import { useEffect, useState } from 'react';
import SettingsService from '../services/settingsService';

// Last resolved unit, so subsequent mounts render correctly on first paint
// instead of flashing metric → imperial while settings load.
let _lastResolved = null;

/**
 * The current user's resolved distance unit: 'metric' | 'imperial'.
 * Defaults to metric (anonymous visitors and load errors). Pass the result
 * to formatDistance()/formatDistanceKm() from utils/distanceFormat.
 */
export default function useDistanceUnit() {
  const [unit, setUnit] = useState(_lastResolved || 'metric');

  useEffect(() => {
    let alive = true;
    SettingsService.getDistanceUnit()
      .then((resolved) => {
        _lastResolved = resolved;
        if (alive && resolved !== unit) setUnit(resolved);
      })
      .catch(() => { /* keep metric */ });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return unit;
}
